import React from 'react'

import { TextProps, Text } from 'components/Text'

export type ErrorMessageProps = Partial<TextProps>

const ErrorMessage = ({ children, ...props }: ErrorMessageProps) => {
  if (!children) {
    return null
  }

  return (
    <Text as="p" variant="caption-bold" color="color-danger" {...props}>
      {children}
    </Text>
  )
}

export default ErrorMessage
